import React from "react"

import Layout from "../components/layout"
import SEO from "../components/seo"

import Referrals from '../components/referrals/referrals';

const ReferralsPage = () => (
  <Layout>
    <SEO title="Referrals" />  
    <Referrals/>
  </Layout>

)

export default ReferralsPage